"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M23 3H1v16h7v2h8v-2h6.99zm-2 14H3V5h18z"
}), 'TvSharp');